import { AntCard as Card, Button, Tooltip } from "@murm/ant";
import styles from "../DataCatalog.module.css";
import { PENDO_ID, pendoId } from "../../../lib/pendoIds";
import { cx } from "../../../lib/classNames";

/**
 * `hideOptions`: for a continuous metric or a categorical metric's value, aggregation
 * (Sum/Average, Count/Percent) is no longer chosen at selection time -- that choice moved to the
 * results page's own toggle. The whole card becomes the selection control instead, defaulting to
 * `options[0]` (whatever the feature's `available_aggregations` lists first), rather than
 * requiring a specific aggregation button click to select at all. An estimate metric's year
 * picker is unrelated (years aren't an aggregation) and keeps the multi-button UI, `hideOptions`
 * left at its default `false`.
 */
const MetricCard = ({
  title,
  description,
  options,
  onOptionSelect,
  isOptionSelected,
  hideOptions = false,
}) => {
  const isSelected = hideOptions && isOptionSelected(options[0]);
  const card = (
    <Card
      {...pendoId(PENDO_ID.CATALOG_METRIC_CARD)}
      hoverable={hideOptions}
      onClick={hideOptions ? () => onOptionSelect(options[0]) : undefined}
      className={cx(styles.card, isSelected && styles.selected)}
      classNames={{ body: styles.metricBody }}
    >
      <div className={styles.metricTitle}>
        <span className={styles.cardLabel}>{title}</span>
      </div>
      {!hideOptions && (
        <div className={styles.metricOptions}>
          {options.map((option) => (
            <Button
              {...pendoId(PENDO_ID.CATALOG_METRIC_OPTION, option)}
              key={option}
              size="small"
              type={isOptionSelected(option) ? "primary" : "default"}
              onClick={() => onOptionSelect(option)}
            >
              {option}
            </Button>
          ))}
        </div>
      )}
    </Card>
  );

  if (!description?.trim()) return card;
  return <Tooltip title={description}>{card}</Tooltip>;
};

export { MetricCard };
